// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"81572761","219":"02eaff71","240":"b460ae7e","267":"a2f90d6d","712":"47fbdc1c","787":"ecfc6e73","816":"087803ee","891":"fc0a6eca"}[chunkId] + ".chunk.js";
};